import React, { useState } from 'react';
import ProductCard from './ProductCard'; // We'll update this next

const ProductGallery = () => {
    const [activeFilter, setActiveFilter] = useState('all');
    const [selectedProduct, setSelectedProduct] = useState(null);

    const products = [
        {
            id: 1,
            name: 'Industrial Rolling Shutter',
            category: 'industrial',
            image: process.env.PUBLIC_URL + '/images/industrial_shutter_1768733704767.png',
            description: 'Heavy-duty galvanized steel shutters designed for warehouses and factories.',
            features: ['Corrosion resistant', 'High strength', 'Motorized option', 'Weather proof']
        },
        {
            id: 2,
            name: 'Transparent Rolling Shutter',
            category: 'commercial',
            image: process.env.PUBLIC_URL + '/images/transparent_shutter_1768733720861.png',
            description: 'Modern polycarbonate shutters perfect for retail stores and showrooms.',
            features: ['Crystal clear visibility', 'UV protection', 'Lightweight', 'Modern design']
        },
        {
            id: 3,
            name: 'Fire Rated Shutter',
            category: 'industrial',
            image: process.env.PUBLIC_URL + '/images/fire_rated_shutter_1768733741229.png',
            description: 'Safety-certified fire-rated shutters for hazardous environments.',
            features: ['2-hour fire rating', 'ATEX certified', 'Emergency release', 'Safety compliant']
        },
        {
            id: 4,
            name: 'Double Wall Shutter',
            category: 'commercial',
            image: process.env.PUBLIC_URL + '/images/double_wall_shutter_1768733758061.png',
            description: 'Insulated double-wall shutters for temperature control and noise reduction.',
            features: ['Thermal insulation', 'Noise reduction', 'Energy efficient', 'Premium finish']
        },
        {
            id: 5,
            name: 'Motorized Smart Shutter',
            category: 'residential',
            image: process.env.PUBLIC_URL + '/images/motorized_shutter_1768733776288.png',
            description: 'Smart motorized shutters with remote control and automation features.',
            features: ['Smart control', 'Remote operation', 'Auto sensors', 'Silent motor']
        }
    ];

    const filteredProducts = activeFilter === 'all'
        ? products
        : products.filter(p => p.category === activeFilter);

    return (
        <section id="products" className="py-24 bg-dark-900 relative">
            <div className="container mx-auto px-6">

                {/* Header */}
                <div className="text-center mb-16 reveal-on-scroll">
                    <h2 className="text-4xl md:text-5xl font-display font-bold mb-4">
                        Exclusive <span className="text-royal-500">Collection</span>
                    </h2>
                    <div className="w-16 h-1 bg-royal-500 mx-auto rounded-full mb-6" />
                    <p className="text-gray-400 max-w-2xl mx-auto text-lg">
                        Discover our comprehensive range of premium rolling shutters designed for every application.
                    </p>
                </div>

                {/* Filters */}
                <div className="flex flex-wrap justify-center gap-4 mb-16 reveal-on-scroll">
                    {['all', 'industrial', 'commercial', 'residential'].map(filter => (
                        <button
                            key={filter}
                            onClick={() => setActiveFilter(filter)}
                            className={`px-8 py-3 rounded-full text-sm font-bold uppercase tracking-wider transition-all duration-300 border border-royal-500/30 ${activeFilter === filter
                                ? 'bg-royal-500 text-white shadow-glow-orange scale-105'
                                : 'bg-transparent text-gray-400 hover:text-royal-500 hover:border-royal-500'
                                }`}
                        >
                            {filter}
                        </button>
                    ))}
                </div>

                {/* Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {filteredProducts.map((product) => (
                        <ProductCard
                            key={product.id}
                            product={product}
                            onClick={setSelectedProduct}
                        />
                    ))}
                </div>
            </div>

            {/* Modal */}
            {selectedProduct && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-dark-900/90 backdrop-blur-sm"
                    onClick={() => setSelectedProduct(null)}
                >
                    <div
                        className="bg-dark-800 border border-royal-500/20 rounded-2xl overflow-hidden max-w-4xl w-full flex flex-col md:flex-row shadow-2xl transform transition-transform scale-100"
                        onClick={e => e.stopPropagation()}
                    >
                        {/* Image Side */}
                        <div className="w-full md:w-1/2 h-64 md:h-auto bg-dark-700 relative">
                            <img
                                src={selectedProduct.image}
                                alt={selectedProduct.name}
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-dark-900 via-transparent to-transparent opacity-60" />
                        </div>

                        {/* Content Side */}
                        <div className="w-full md:w-1/2 p-8 md:p-12 flex flex-col">
                            <button
                                onClick={() => setSelectedProduct(null)}
                                className="self-end text-gray-400 hover:text-royal-500 text-3xl leading-none mb-4"
                            >
                                &times;
                            </button>

                            <h3 className="text-3xl font-display font-bold text-white mb-2">{selectedProduct.name}</h3>
                            <p className="text-royal-500 uppercase text-xs tracking-widest font-bold mb-6">{selectedProduct.category}</p>

                            <p className="text-gray-300 mb-8 leading-relaxed">
                                {selectedProduct.description}
                            </p>

                            <div className="mb-8">
                                <h4 className="text-sm font-bold uppercase text-gray-400 mb-4 tracking-wider">Key Features</h4>
                                <ul className="grid grid-cols-1 gap-3">
                                    {selectedProduct.features.map((feature, i) => (
                                        <li key={i} className="flex items-center text-gray-200">
                                            <span className="w-2 h-2 rounded-full bg-royal-500 mr-3 shadow-glow-orange" />
                                            {feature}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <button className="mt-auto w-full btn-royal uppercase tracking-widest text-sm py-4">
                                Request Quote
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default ProductGallery;
